/*
 * File: AppConfig.js
 * Project: reports
 * Created Date: Monday July 30th 2018
 * Author: Austin Smith
 * -----
 * Last Modified: Monday, 29th October 2018 8:34:57 pm
 * Modified By: Austin Smith (austin.smith918@yahoo.com>)
 * -----
 * Copyright (c) 2018 Teaming
 */

/**
 * App Config File
 */
import envConfig from "../../config/env-vars-CONFIG_TARGET";

const config = {
	appMark: "/static/logos/teaming-logo-dark.png",
	appLogo3: "/static/logos/session-logo-white.png", // App Logo 3 For Login & Signup Page
	companyLink: "https://www.teaming.com",
	termsLink: "https://www.teaming.com/terms-of-service/",
	policyLink: "https://www.teaming.com/privacy-policy/",
	coachingLink: "https://calendly.com/kate-oneil1/teaming-coaching-call",
	demoLink: "https://calendly.com/kate-oneil1/30-minute-meeting",
	...envConfig,
};

export default config;

export const defaultInputColor = "#6772e6";
export const defaultAvatarColor = "#A7AEF1";



// WEBPACK FOOTER //
// ./src/constants/AppConfig.js